import { EXPRESS_API } from 'configs/api/expressApi';

export const inviteFriends = async (friends: string[]) => {
  const data = {
    friends,
  };
  const response = await EXPRESS_API.post(`/invite-friends`, data);
  return response.data;
};
